import CompaniesView from "../CompaniesView.vue";
import ContractList from "../Pages/ContractList.vue";
import ContractEditor from "../Pages/ContractEditor.vue";
import ContractDetail from "../Pages/ContractDetail.vue";
import ContractBulkUploadPage from "../Pages/ContractBulkUploadPage.vue";
import ContractBulkEditPage from "../Pages/ContractBulkEditPage.vue";
import ContractAddendaBulk from "../Pages/ContractAddendaBulk.vue";

const routes = [
  {
    path: '/contratos',
    component: CompaniesView,
    children: [
      {
        path: '',
        name: 'contracts-list',
        component: ContractList,
      },
      {
        path: 'carga-masiva',
        name: 'contracts-bulk-upload',
        component: ContractBulkUploadPage,
      },
      {
        path: 'edicion-masiva',
        name: 'contracts-bulk-edit',
        component: ContractBulkEditPage,
      },
      {
        path: 'adenda-masiva',
        name: 'contracts-addenda-bulk',
        component: ContractAddendaBulk,
      },
      {
        path: 'crear',
        name: 'contracts-create',
        component: ContractEditor,
      },
      {
        path: ':id/editar',
        name: 'contracts-edit',
        component: ContractEditor
      },
      {
        path: ':id/detalle',
        name: 'contracts-detail',
        component: ContractDetail
      },
    ]
  }
]

export default routes
